export const getEnumKeyByEnumValue = <T extends {[index: string]: string}>(myEnum: T, enumValue: string): keyof T | undefined => {
    const keys = Object.keys(myEnum).filter(x => myEnum[x] === enumValue)

    return keys.length > 0 ? keys[0] : undefined
}
